/** @jsx createElement */
// SVG
import { Card } from '../svg/card';
import { Person } from '../svg/person';
// Other
import { observer } from 'mobx-react';
import { createElement, Component, HTMLAttributes } from 'react';
import { activate, deactivate, shimmer, activateShimmer } from '../helpers';
import { AnimatedSlide } from '../animated-slide';
import { PlayerTextBlock } from '../players/text-block';

@observer
export class Slide12 extends AnimatedSlide {
  // Animation players
  players = {
    events1: null,
    events2: null,
  };

  // Run the first animation
  componentDidMount() {
    const { events1, events2 } = this.players;

    this.steps = [
      () => {
        this.animateProgress(2000);
        this.autoNext(2000);
      },
      () => {},
    ];

    this.animations = [
      //
      // Step 1
      //
      [
        {
          targets: events1,
          opacity: 1,
          duration: 500,
          delay: 0,
          begin: activateShimmer,
        },
      ],
      //
      // Step 2
      //
      [
        {
          targets: events2,
          opacity: 1,
          duration: 500,
          delay: 0,
          begin: activateShimmer,
        },
      ],
    ];

    // Play the first animation
    this.play();
  }

  render() {
    const { children, className = '' } = this.props;

    return (
      <div className={`slide-12 ${className}`}>
        {children}
        <div className="content">
          {/* Last 30 */}
          <div
            className="player events1"
            data-active="0"
            ref={node => (this.players.events1 = node)}
          >
            <PlayerTextBlock
              title={'events (Last 30 days)'}
              width={'250px'}
              className={''}
              sections={[
                {
                  title: ['CREATE USER', '2'],
                  grid: 2,
                  lines: 4,
                  lineColumns: 2,
                },
              ]}
            />
          </div>

          {/* Last 24 */}
          <div
            className="player events2"
            data-active="0"
            ref={node => (this.players.events2 = node)}
          >
            <PlayerTextBlock
              title={'events (Last 24 days)'}
              width={'250px'}
              className={''}
              sections={[
                {
                  title: ['CREATE USER', '1'],
                  grid: 2,
                  lines: 4,
                  lineColumns: 2,
                },
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}
